import { ReactComponent as IconProgressMarkComponent } from "./svg/progress_mark.svg";

type Props = {
  width?: string;
  height?: string;
  marginTop?: string;
};

export const IconProgressMark = ({ width, height, marginTop }: Props) => {
  return <IconProgressMarkComponent style={{ width, height, marginTop }} />;
};
